module.exports = __webpack_public_path__ + "img/9.b94e54f9.png";